module.exports = __webpack_public_path__ + "static/media/Noel.7dd9beb3.jpg";